import React, { useState } from 'react';
import { LocStr } from '../utils/Utils';
import {
  app_background_color,
  border_color,
  border_light_color,
  Colors_str,
  cta_font_color,
  disabled_cta_color,
  Elements_background_colors,
  Font_colors,
  light_elements_color,
  links_icons_color,
  menu_balance_color,
  menu_primary_color,
  menu_secondary_color,
  menu_top_area_color,
  negative_color,
  positive_color,
  pressed_cta_color,
  primary_cta_color,
  primary_font_color,
  Reset_all_colors,
  secondary_font_color,
  Set_appearance_brand,
  tertiary_icons_color,
  want_reset_all_properties,
} from '../utils/DictionaryManagementUtils';
import ColorsMenu from '../components/PanelsComponents/Colors/ColorsMenu';
import LinkTextButton from '../components/PanelsComponents/Buttons/LinkTextButton';
import QuestionPopup from '../components/PanelsComponents/General/QuestionPopup';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import { getDefaultGlobJSON } from '../defaultConfigurations/MainConfigurations';
//= ========================================================================

const Panel_X01_themeColors = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const { colors } = globJSON.configurations.theme;

  const [questionPopupState, setQuestionPopupState] = useState({
    isQuestionVisible: false,
    title: '',
  });
  const onResetPropertiesApproved = () => {
    const colorsDefault = getDefaultGlobJSON().configurations.theme.colors;
    colors.primary_font_color = colorsDefault.primary_font_color;
    colors.secondary_font_color = colorsDefault.secondary_font_color;
    colors.tertiary_icons_color = colorsDefault.tertiary_icons_color;
    colors.cta_font_color = colorsDefault.cta_font_color;
    colors.links_icons_color = colorsDefault.links_icons_color;
    colors.menu_primary_color = colorsDefault.menu_primary_color;
    colors.menu_secondary_color = colorsDefault.menu_secondary_color;
    colors.primary_cta_color = colorsDefault.primary_cta_color;
    colors.disabled_cta_color = colorsDefault.disabled_cta_color;
    colors.pressed_cta_color = colorsDefault.pressed_cta_color;
    colors.app_background_color = colorsDefault.app_background_color;
    colors.border_color = colorsDefault.border_color;
    colors.border_light_color = colorsDefault.border_light_color;
    colors.light_elements_color = colorsDefault.light_elements_color;
    colors.menu_balance_color = colorsDefault.menu_balance_color;
    colors.menu_top_area_color = colorsDefault.menu_top_area_color;
    colors.positive_color = colorsDefault.positive_color;
    colors.negative_color = colorsDefault.negative_color;

    setQuestionPopupState({
      isQuestionVisible: false,
      title: '',
    });
    onConfigChanged();
  };
  const colorAList = [
    primary_font_color,
    secondary_font_color,
    tertiary_icons_color,
    cta_font_color,
    links_icons_color,
    menu_primary_color,
    menu_secondary_color,
  ];
  const colorBList = [
    primary_cta_color,
    disabled_cta_color,
    pressed_cta_color,
    border_color,
    border_light_color,
    light_elements_color,
    menu_top_area_color,
    menu_balance_color,
    app_background_color,
    positive_color,
    negative_color,
  ];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Colors_str}
      paragraph={Set_appearance_brand}
      tooltipsTitles={globJSON.configurations.theme.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >
      <ColorsMenu globJSON={globJSON} onConfigChanged={onConfigChanged} headline={LocStr(Font_colors, language)} colorList={colorAList} />
      <ColorsMenu globJSON={globJSON} onConfigChanged={onConfigChanged} headline={LocStr(Elements_background_colors, language)} colorList={colorBList} />
      <LinkTextButton
        onPress={() => {
          setQuestionPopupState({
            isQuestionVisible: true,
            title: LocStr(want_reset_all_properties, language),
          });
        }}
      >
        {LocStr(Reset_all_colors, language)}
      </LinkTextButton>
      {questionPopupState.isQuestionVisible && (
        <QuestionPopup
          onYesPressed={() => {
            onResetPropertiesApproved();
          }}
          onNoPressed={() => setQuestionPopupState({
            isQuestionVisible: false,
            title: '',
          })}
          question={questionPopupState.title}
          language={language}
        />
      )}
    </FullPagePanel>
  );
};

export default Panel_X01_themeColors;
